import Modal from "@atoms/Modal/Modal";
import SelectBox from "@atoms/SelectBox/SelectBox";
import useModal from "@hooks/useModal";
import IconFilterClassification from "@images/pressList/icon-filter-classification-white.svg";
import IconFilterStatus from "@images/pressList/icon-filter-status-white.svg";
import { useRegulatoryListFilterState } from "@stores/regulatoryList";

import RegulatoryClassificationFilter from "./components/RegulatoryClassificationFilter/RegulatoryClassificationFilter";
import RegulatorySearch from "./components/RegulatorySearch/RegulatorySearch";
import RegulatorySearchResult from "./components/RegulatorySearchResult/RegulatorySearchResult";
import StatusFilter from "./components/StatusFilter/StatusFilter";
import * as S from "./RegulatoryTableFilter.style";

const LIMIT_NUMBER_LIST = [20, 40, 60, 80, 100];

const RegulatoryTableFilter = () => {
  const [regulatoryListFilter, setRegulatoryListFilter] =
    useRegulatoryListFilterState();

  const { pageLimit, status, classification } = regulatoryListFilter;

  const {
    isModal: isClassificationFilterModalOpen,
    openModal: openClassificationFilterModal,
    closeModal: closeClassificationFilterModal,
  } = useModal();
  const {
    isModal: isStatusFilterModalOpen,
    openModal: openStatusFilterModal,
    closeModal: closeStatusFilterModal,
  } = useModal();

  const selectedClassificationNumber = classification.length;
  const selectedStatusNumber = status.length;

  const handleSelectLimitNumber = (value: string) => {
    setRegulatoryListFilter({
      ...regulatoryListFilter,
      pageLimit: Number(value),
      page: 1,
    });
  };

  return (
    <>
      <S.RegulatoryListTableFilterWrapper>
        <S.FilterContainer>
          <S.LeftControls>
            <RegulatorySearch />
            <S.FilterButtonsContainer>
              <S.FilterButton
                buttonWidth={14.8}
                buttonSize="xSmall"
                buttonStyle="solidSky"
                onClick={openClassificationFilterModal}
              >
                <img
                  src={IconFilterClassification}
                  alt="classification filter"
                />
                Classification Filter
                {selectedClassificationNumber > 0 &&
                  `(${selectedClassificationNumber})`}
              </S.FilterButton>
              <S.FilterButton
                buttonSize="xSmall"
                buttonStyle="solidBlueGreen"
                onClick={openStatusFilterModal}
              >
                <img src={IconFilterStatus} alt="status filter" />
                Status Filter
                {selectedStatusNumber > 0 && `(${selectedStatusNumber})`}
              </S.FilterButton>
            </S.FilterButtonsContainer>
          </S.LeftControls>
          <S.RightControls>
            <SelectBox
              optionList={LIMIT_NUMBER_LIST}
              defaultText=" accounts per page"
              selectValue={pageLimit}
              onChangeOption={handleSelectLimitNumber}
            />
          </S.RightControls>
        </S.FilterContainer>
        {isClassificationFilterModalOpen && (
          <Modal closeModal={closeClassificationFilterModal}>
            <RegulatoryClassificationFilter
              closeModal={closeClassificationFilterModal}
            />
          </Modal>
        )}
        {isStatusFilterModalOpen && (
          <Modal closeModal={closeStatusFilterModal}>
            <StatusFilter closeModal={closeStatusFilterModal} />
          </Modal>
        )}
      </S.RegulatoryListTableFilterWrapper>
      <RegulatorySearchResult />
    </>
  );
};

export default RegulatoryTableFilter;
